import React from 'react';
import { get } from 'lodash';
import Kostengruppe, { GetKostenFormStruc } from '../kosten/Kostengruppe';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import Schema from '../../../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';

const P = Schema.attributes;

export const GetKosten = (application: any, kostenposition: string, kostenart: string, kostenKategories: any) => {
    const OrgaStruc = [
        {
            label: 'Antragsteller',
            content: <Kostengruppe kostenposition={kostenposition} kostenart={kostenart} kostentraeger="Antragsteller" unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
            formStruc: GetKostenFormStruc(application, kostenposition, kostenart, get(getLocalstorageToken(), 'organisationId'), 'Antragsteller', kostenKategories),
        },
    ];
    const PartnerStruc = get(application, P.Partner.path, []).map((ele: any, i: number) => {
        return {
            label: get(ele, 'Unternehmen.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation', `Partner ${i + 1}`),
            content: <Kostengruppe kostenposition={kostenposition} kostenart={kostenart} kostentraeger="Projektpartner" unternehmenId={get(ele, 'Unternehmen.id')} />,
            formStruc: GetKostenFormStruc(application, kostenposition, kostenart, get(ele, 'Unternehmen.id'), 'Projektpartner', kostenKategories),
        };
    });

    return [...OrgaStruc, ...PartnerStruc];
};
